<template>
  <v-card flat>
    <v-card-text>
      <v-tabs
        grow
        v-model="tab"
        slider-size="3"
        background-color="green lighten-4"
      >
        <v-tab active-class="font-weight-bold">Meus Dados</v-tab>
        <v-tab active-class="font-weight-bold">Solicitações</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat color="grey lighten-4" class="mt-2" rounded>
            <v-card-text>
              <v-alert type="warning" text v-if="temSolicitacaoPendente()">
                Solicitação com pendências. Verifique!
              </v-alert>
              <template v-else>
                <v-card flat class="mb-3">
                  <v-card-title>Escolaridade</v-card-title>
                  <v-card-text>
                    <v-row
                      v-for="(item, index) in escolaridade"
                      :key="index"
                      class="mb-0 ma-1"
                    >
                      {{ item.descricao }}
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-card flat class="mb-3 pa-0">
                  <v-card-title>Área de Formação</v-card-title>
                  <v-card-text>
                    <div v-if="getCursosPorTipo(10).length">
                      <v-row no-gutters class="mb-0">
                        <v-col cols="4"
                          ><strong class="titleStrong"
                            >Nível Técnico</strong
                          ></v-col
                        >
                        <v-col cols="4"><strong>Início</strong></v-col>
                        <v-col cols="4"><strong>Término</strong></v-col>
                      </v-row>
                      <v-row
                        no-gutters
                        v-for="(curso, index) in getCursosPorTipo(10)"
                        :key="index"
                      >
                        <v-col cols="4">{{ curso.titulo }}</v-col>
                        <v-col cols="4">{{ curso.inicio }}</v-col>
                        <v-col cols="4">{{ curso.termino }}</v-col>
                      </v-row>
                    </div>

                    <div v-if="getCursosPorTipo(50).length" class="mt-2">
                      <v-row no-gutters class="mb-0">
                        <v-col cols="4"
                          ><strong class="titleStrong">Graduação</strong></v-col
                        >
                        <v-col cols="4"><strong>Início</strong></v-col>
                        <v-col cols="4"><strong>Término</strong></v-col>
                      </v-row>
                      <v-row
                        no-gutters
                        v-for="(curso, index) in getCursosPorTipo(50)"
                        :key="index"
                      >
                        <v-col cols="4">{{ curso.titulo }}</v-col>
                        <v-col cols="4">{{ curso.inicio }}</v-col>
                        <v-col cols="4">{{ curso.termino }}</v-col>
                      </v-row>
                    </div>

                    <div v-if="getCursosPorTipo(51).length" class="mt-2">
                      <v-row no-gutters class="mb-0">
                        <v-col cols="4"
                          ><strong class="titleStrong"
                            >Especialização</strong
                          ></v-col
                        >
                        <v-col cols="4"><strong>Início</strong></v-col>
                        <v-col cols="4"><strong>Término</strong></v-col>
                      </v-row>
                      <v-row
                        no-gutters
                        v-for="(curso, index) in getCursosPorTipo(51)"
                        :key="index"
                      >
                        <v-col cols="4">{{ curso.titulo }}</v-col>
                        <v-col cols="4">{{ curso.inicio }}</v-col>
                        <v-col cols="4">{{ curso.termino }}</v-col>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>

                <modal-atualiz-escolaridade />
              </template>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-alert
            v-if="filteredSolicitacoes.length == 0"
            type="info"
            text
            class="mt-3"
          >
            Não há solicitações para alteração de escolaridade
          </v-alert>
          <v-list color="grey lighten-4" class="mt-2 rounded-lg">
            <v-list-item
              v-for="(solic, i) in filteredSolicitacoes"
              :key="i"
              class="mt-2"
            >
              <v-list-item-icon v-if="!isMobile()">
                <v-chip small dark :style="colorStatus(solic.cores)">{{
                  solic.descstatus
                }}</v-chip>
              </v-list-item-icon>
              <v-list-item-content class="ml-2">
                <v-list-item-title>{{ solic.descsituacao }}</v-list-item-title>
                <v-list-item-subtitle class="caption">
                  Solicitação realizada em
                  {{ formatarData(solic.datainicio) }} às
                  {{ solic.horainicio }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="isMobile()" class="mt-2">
                  <v-chip small dark :style="colorStatus(solic.cores)">{{
                    solic.descstatus
                  }}</v-chip>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="temSolicitacaoPendente()">
                  <modal-atualiz-escolaridade />
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <opcoes-solic-atualiz-cad :solic="solic" />
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { dateFormat } from "@/global";
import { mapGetters, mapState, mapActions } from "vuex";
import ModalAtualizEscolaridade from "./ModalAtualizEscolaridade.vue";
import OpcoesSolicAtualizCad from "./OpcoesSolicAtualizCad.vue";

export default {
  components: { ModalAtualizEscolaridade, OpcoesSolicAtualizCad },
  computed: {
    ...mapState("atualizacaoCadastral", [
      "dadosCadastrais",
      "solicitacoes",
      "escolaridade",
      "formacao",
    ]),
    filteredSolicitacoes() {
      return this.solicitacoes.filter(
        (solic) => solic.codconfigsituacao === 49
      );
    },
  },
  data: () => ({
    tab: 0,
  }),
  methods: {
    ...mapGetters("atualizacaoCadastral", ["temSolicitacaoPendente"]),
    ...mapActions("atualizacaoCadastral", ["getSolicitacoes"]),
    formatarData(value) {
      return dateFormat(value);
    },
    colorStatus(colors) {
      return `background: rgba(${colors[0].cor},${colors[1].cor},${colors[2].cor},.7)`;
    },
    isMobile() {
      return this.$mq == "sm";
    },
    getCursosPorTipo(tipo) {
      return this.formacao
        .filter((curso) => curso.tipo === tipo)
        .map((curso) => {
          if (curso.situacao === "Cursando") {
            return {
              ...curso,
              titulo: `${curso.titulo} (Cursando)`,
            };
          }
          return curso;
        });
    },
  },
  mounted() {
    this.getSolicitacoes();
  },
};
</script>

<style>
.v-row.no-gutters [class*="col-"] {
  padding-left: 0;
  padding-right: 0;
}

.titleStrong {
  font-size: 14px;
}
</style>
